import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";

interface CommitmentsOverviewSectionLegendProps {
  label: string;
  color: string;
}

export const CommitmentsOverviewSectionLegend: FC<
  CommitmentsOverviewSectionLegendProps
> = ({ label, color }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <SquareRoundedIcon
        sx={{
          fontSize: 12,
          color,
        }}
      />
      <Typography variant="body2" fontWeight="medium">
        {label}
      </Typography>
    </Stack>
  );
};
